import styled from "styled-components";
import { theme } from "styles";

const Text = styled.span`
  display: ${(props) => props.display};
  color: ${(props) => theme.colors[props.color] || props.color};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  line-height: ${(props) => props.lineHeight};
  ${(props) => props.css}
`;

Text.defaultProps = {
  display: "inline-block",
  color: "gray100",
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "20px",
};

export default Text;
